/* eslint-disable max-len */
import { muiColors } from "themes/colors";
import { CustomButton } from "./CustomButton";
import { IconButton, Dialog, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ConfirmationModalProps {
  handleConfirm: () => void;
  onClose: () => void;
  text: string;
  buttonText: string;
  open: boolean;
  title?: string;
  buttonBg?: string;
  buttonTextColor?: string;
  centerAlign?: boolean;
  handleReject?: () => void;
  rejectText?: string;
  disabled?: boolean;
  submitting?: boolean;
}

export default function ConfirmationModal({
  handleConfirm,
  onClose,
  text,
  buttonText,
  open,
  title,
  disabled,
  submitting,
  buttonBg = muiColors.error,
  buttonTextColor = muiColors.button.contrast,
  centerAlign = false,
  handleReject,
  rejectText
}: ConfirmationModalProps) {
  return (
    <Dialog
      title={title}
      open={Boolean(open)}
      onClose={onClose}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: muiColors.paper,
          borderRadius: "8px"
        },
        "& #edit-dialog-title": {
          textAlign: "center",
          textTransform: "uppercase",
          fontFamily: "Inter",
          fontSize: "14px"
        },
        "& .RaFormDialogTitle-closeButton": {
          display: "none"
        }
      }}
    >
      <DialogTitle>
        <IconButton
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px"
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <div className={centerAlign ? "flex flex-col items-center p-4" : "p-4"}>
        <p>{text}</p>
        <div className="flex justify-end mt-6 gap-4">
          {handleReject && (
            <CustomButton
              onClick={handleReject}
              text={rejectText || "No"}
              variant="secondary"
            />
          )}
          <CustomButton
            onClick={handleConfirm}
            text={buttonText}
            disabled={disabled}
            submitting={submitting}
            endIcon={<div />}
            sx={{
              backgroundColor: buttonBg,
              color: buttonTextColor,
              "&:hover": {
                backgroundColor: buttonBg,
                opacity: 0.9
              }
            }}
          />
        </div>
      </div>
    </Dialog>
  );
}
